import { Copy, ShieldCheck } from 'lucide-react';

/**
 * CorrespondanceBadge — tiny inline pill rendering a lot's correspondance.
 *
 *   • "Unique" lot      → discreet emerald pill (omitted by default — most
 *     lots are unique; we only highlight similars to reduce visual noise).
 *   • "Similaire à XXX" → sky-blue pill with the reference lot number.
 *
 * Pass `showUnique` to render both kinds (useful in the Generation list and
 * the Lot card).
 */
const CorrespondanceBadge = ({ correspondance, showUnique = false, size = 'sm', testid }) => {
  const corr = (correspondance || 'Unique').trim();
  const isUnique = !corr || corr.toLowerCase() === 'unique' || corr.toLowerCase() === 'u';

  if (isUnique && !showUnique) return null;

  const cls = size === 'xs'
    ? 'text-[9.5px] px-1 py-px gap-0.5'
    : 'text-[10.5px] px-1.5 py-0.5 gap-1';

  if (isUnique) {
    return (
      <span
        className={`inline-flex items-center rounded-full font-medium tracking-wider uppercase shrink-0 ${cls}`}
        style={{
          background: 'rgba(16,185,129,0.10)',
          color: '#047857',
          border: '1px solid rgba(16,185,129,0.30)',
        }}
        data-testid={testid || 'lot-correspondance-badge-unique'}
        title="Lot unique — shoebox généré indépendamment"
      >
        <ShieldCheck className="w-2.5 h-2.5" strokeWidth={2.4} />
        Unique
      </span>
    );
  }

  return (
    <span
      className={`inline-flex items-center rounded-full font-medium tracking-wider shrink-0 ${cls}`}
      style={{
        background: 'rgba(56,189,248,0.12)',
        color: '#0369A1',
        border: '1px solid rgba(56,189,248,0.35)',
      }}
      data-testid={testid || 'lot-correspondance-badge-similar'}
      title={`Similaire au lot ${corr} — partage son shoebox`}
    >
      <Copy className="w-2.5 h-2.5" strokeWidth={2.4} />
      ≈ {corr}
    </span>
  );
};

export default CorrespondanceBadge;
